const viewTransaction = {
  methods: {
    viewTransaction(transaction) {
      const routes = [
        {type:'Site',name:'SettingsSitesEdit',param:'siteId'},

        {type:'Formula',name:'ProductionBlendingFormulasEdit',param:'formulaId'},
        {type:'Blend',name:'ProductionBlendingEdit',param:'blendId'},

        {type:'Bottling',name:'ProductionBottlingEdit',param:'bottlingId'},
        {type:'Packing',name:'ProductionPackingEdit',param:'packingId'},

        {type:'BulkContainer',name:'InventoryBulkContainersEdit',param:'bulkContainerId'},

        {type:'Cask',name:'InventoryCasksEdit',param:'caskId'},

        {type:'Customer',name:'SalesCustomersEdit',param:'customerId'},
        {type:'Vendor',name:'PurchasingSuppliersEdit',param:'supplierId'},

        {type:'Process',name:'ProductionDistillingProcessesEdit',param:'processId'},
        {type:'Distillation',name:'ProductionDistillingEdit',param:'distillationId'},

        {type:'Still',name:'EquipmentStillsEdit',param:'stillId'},

        {type:'Fermenter',name:'EquipmentFermentersEdit',param:'fermenterId'},
        {type:'FermenterTransactionReduceInventory',name:'EquipmentFermentersReduceInventory',param:'transactionId'},
        {type:'FermenterTransactionTransfer',name:'EquipmentFermentersTransferToFermenter',param:'transactionId'},

        {type:'Item',name:'InventoryItemsEdit',param:'itemId'},
        {type:'ItemTransactionAdjustInventory',name:'InventoryItemsAdjustInventory',param:'transactionId'},
        {type:'ItemTransactionTransferSite',name:'InventoryItemsTransferSite',param:'transactionId'},
        {type:'ItemTransactionTransferLot',name:'InventoryItemsTransferLot',param:'transactionId'},

        {type:'Bundle',name:'InventoryBundlesEdit',param:'bundleId'},

        {type:'MashBill',name:'ProductionMashingMashBillsEdit',param:'mashBillId'},
        {type:'Mash',name:'ProductionMashingEdit',param:'mashId'},

        {type:'WineFermentation',name:'ProductionWineFermentingEdit',param:'fermentationId'},

        {type:'Product',name:'InventoryProductsEdit',param:'productId'},
        {type:'ProductTransactionReduceInventory',name:'InventoryProductsReduceInventory',param:'transactionId'},
        {type:'ProductTransactionAdjustInventory',name:'InventoryProductsAdjustInventory',param:'transactionId'},
        {type:'ProductTransactionTransferSite',name:'InventoryProductsTransferSite',param:'transactionId'},
        {type:'ProductTransactionMoveToDutyPaid',name:'InventoryProductsMoveToDutyPaid',param:'transactionId'},
        {type:'ProductTransactionMoveToInBond',name:'InventoryProductsMoveToInBond',param:'transactionId'},
        {type:'ProductTransactionReturnToTank',name:'InventoryProductsReturnToTank',param:'transactionId'},
        {type:'ProductTransactionUnpack',name:'InventoryProductsUnpack',param:'transactionId'},
        {type:'ProductTransactionConvert',name:'InventoryProductsConvert',param:'transactionId'},
        {type:'ProductTransactionTransferLot',name:'InventoryProductsTransferLot',param:'transactionId'},

        {type:'Spirit',name:'SpiritsEdit',param:'spiritId'},
        {type:'Wine',name:'WineEdit',param:'wineId'},

        {type:'ExciseVesselTransactionInitial',name:'ExciseVesselInitialUpdate',param:'transactionId'},
        {type:'ExciseVesselTransactionReduceInventory',name:'ExciseVesselReduceInventory',param:'transactionId'},
        {type:'ExciseVesselTransactionFortifyWine',name:'ExciseVesselFortifyWine',param:'transactionId'},
        {type:'ExciseVesselTransactionDenature',name:'ExciseVesselDenature',param:'transactionId'},
        {type:'ExciseVesselTransactionAdjustInventory',name:'ExciseVesselAdjustInventory',param:'transactionId'},
        {type:'ExciseVesselTransactionReassignLot',name:'ExciseVesselReassignLot',param:'transactionId'},
        {type:'ExciseVesselTransactionTransferToTank',name:'ExciseVesselTransferToTank',param:'transactionId'},
        {type:'ExciseVesselTransactionTransferToBulkContainer',name:'ExciseVesselTransferToBulkContainer',param:'transactionId'},
        {type:'ExciseVesselTransactionTransferToUserLicense',name:'ExciseVesselTransferToUserLicense',param:'transactionId'},
        {type:'ExciseVesselTransactionTransferToSpiritsLicense',name:'ExciseVesselTransferToSpiritsLicense',param:'transactionId'},
        {type:'ExciseVesselTransactionTransferToWineLicense',name:'ExciseVesselTransferToWineLicense',param:'transactionId'},
        {type:'ExciseVesselTransactionTransferSite',name:'ExciseVesselTransferSite',param:'transactionId'},

        {type:'CasksEmpty',name:'InventoryCasksEmpty',param:'transactionId'},
        {type:'CaskSetAge',name:'InventoryCasksSetAge',param:'transactionId'},

        {type:'Tank',name:'EquipmentTanksEdit',param:'tankId'},
        {type:'TankTransactionProof',name:'EquipmentTanksProof',param:'transactionId'},
        {type:'TankTransactionFillCask',name:'EquipmentTanksFillCask',param:'transactionId'},

        {type:'Receipt',name:'PurchasingInventoryReceiptsEdit',param:'inventoryReceiptId'},
        {type:'PO',name:'PurchasingPurchaseOrdersEdit',param:'poId'},
        {type:'Shipment',name:'SalesShipmentsEdit',param:'shipmentId'},
        {type:'Invoice',name:'SalesInvoicesEdit',param:'invoiceId'},
        {type:'ProductReturn',name:'SalesReturnsEdit',param:'returnId'},

        {type:'SalesOrder',name:'SalesSalesOrders',param:'salesOrderId'},
        {type:'Assembly',name:'ProductionAssemblyEdit',param:'assemblyId'},
        {type:'OtherEquipment',name:'EquipmentOtherEdit',param:'equipmentId'},
        {type:'Tax',name:'SettingsTaxesEdit',param:'taxId'},
        {type:'Term',name:'SettingsTerms',param:'termId'},
        {type:'Role',name:'PlanningSchedulingRoles',param:'roleId'}
      ];
      const route = routes.find(route => route.type === transaction.refType);
      if (route)
        this.$router.push({name:route.name,params:{[route.param]:transaction.refId}});
      else
        this.$store.commit('setError', {type:'Info',message:'No further details'});
    },
  }
}

export default viewTransaction;